import { jsxs as l, jsx as e } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ l(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_864_10221)", children: [
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
            fill: "#F3F3FD"
          }
        ),
        /* @__PURE__ */ e("mask", { id: "path-2-inside-1_864_10221", fill: "white", children: /* @__PURE__ */ e("path", { d: "M43.3076 27H53.1538V33.1346C53.1538 33.825 52.5941 34.3846 51.9038 34.3846H44.5576C43.8673 34.3846 43.3076 33.825 43.3076 33.1346V27Z" }) }),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M43.3076 27H53.1538V33.1346C53.1538 33.825 52.5941 34.3846 51.9038 34.3846H44.5576C43.8673 34.3846 43.3076 33.825 43.3076 33.1346V27Z",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "3.75",
            mask: "url(#path-2-inside-1_864_10221)"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M55.6154 67.6151C55.6154 71.6939 52.3096 74.9997 48.2308 74.9997C44.152 74.9997 40.8462 71.6939 40.8462 67.6151C40.8462 63.5363 44.152 60.2305 48.2308 60.2305C52.3096 60.2305 55.6154 63.5363 55.6154 67.6151Z",
            fill: "white",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31 67.9226C28.7945 67.9226 27 66.1282 27 63.9226C27 61.7171 28.7945 59.9226 31 59.9226H31.9231V45.4611C31.9231 38.5048 37.5822 32.8457 44.5385 32.8457H51.9231C58.8794 32.8457 64.5385 38.5048 64.5385 45.4611V59.9226H65.4615C67.6671 59.9226 69.4615 61.7171 69.4615 63.9226C69.4615 66.1282 67.6671 67.9226 65.4615 67.9226H31Z",
            fill: "white",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M54.1387 40.7846C54.1387 33.1726 60.3102 27 67.9233 27C75.5353 27 81.7079 33.1726 81.7079 40.7846C81.7079 48.3977 75.5353 54.5692 67.9233 54.5692C60.3102 54.5692 54.1387 48.3977 54.1387 40.7846Z",
            fill: "var(--plac-icon-fill-active)"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M73.0884 38.0889L66.0976 45.0796L62.7568 41.7379",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        )
      ] }),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_864_10221", children: /* @__PURE__ */ e("rect", { width: "100", height: "100", fill: "white" }) }) })
    ]
  }
);
export {
  t as BellIllustration
};
//# sourceMappingURL=index.es475.js.map
